module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai711-de9a6127ab716c04b97d584e5e555c0a.jpg";